import { useCallback, useState } from 'react'

import { getAreaLockers, AreaLockersParams } from 'state/ducks/space/apis'
import { Space } from 'state/ducks/space/models.new'

export const useAreaLockers = () => {
  const [lockers, setLockers] = useState<Space[]>([])
  const [isLoading, setLoading] = useState(false)

  const handleGetAreaLockers = useCallback(async (params: AreaLockersParams) => {
    setLoading(true)
    const result = await getAreaLockers(params)

    if (result.isOk) {
      setLockers(result.data)
    }

    setLoading(false)
  }, [])

  return {
    lockers,
    isLoading,
    getAreaLockers: handleGetAreaLockers,
  }
}
